// @flow

import load from './transport';
import timeCodeToSeconds from './timeCodeToSeconds';
import { head, last, map, filter, uidGenerator } from '../../utils';

import type { Player$TimeData } from '../../types/TimeData';

const SCRIPT_TAG_REGEX = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;

export default function loadVTT(url: string, callback: (Player$TimeData[]) => void, error: any) {
   const success = ({data}) => {
      callback(decode(data));
   };
   load({ url, success, error });
}

function decode(data: string): Player$TimeData[] {
   let array = data.split(/\n\s*\n+/gm);

   const format = array.shift().trim();

   if (format !== 'WEBVTT') {
      return [];
   }

   const timeDelim = '-->';

   return map(filter(array), str => {
      const lines = str.split(/\n/g);

      const title = head(lines).indexOf(timeDelim) < 0 ? lines.shift() : '';

      const period = lines.shift().split(timeDelim);
      const from = timeCodeToSeconds(head(period).trim());
      const to = timeCodeToSeconds(last(period).trim());

      const text = lines.filter(l => !!l).join('<br/>&nbsp;').replace(SCRIPT_TAG_REGEX, '');

      return { from, to, text, title, id: uidGenerator() };
   });
}
